const isInviteSet = () => {
    return window.com?.genesyslab?.gpe?.invite?.data;
};

const setInvite = (invite) => {
    window.com = {};
    window.com.genesyslab = {};
    window.com.genesyslab.gpe = {};
    window.com.genesyslab.gpe.invite = {};
    window.com.genesyslab.gpe.invite.data = invite;
};

const preProcessInvite = (invite) => {
    if (invite.cmbOptions?.cmbDelayedAvailable) {
        invite.cmbOptions.cmbDelayedIntervals = invite.cmbOptions.cmbDelayedIntervals.filter(
            (i) => i !== null
        );
    }
    return invite;
};

const getInvite = () => {
    if (isInviteSet()) {
        if (window.resetInvite) {
            setInvite(preProcessInvite(window.resetInvite(window.com.genesyslab.gpe.invite.data)));
        }
        return preProcessInvite(window.com.genesyslab.gpe.invite.data);
    }
    return undefined;
};

export default {
    isInviteSet,
    setInvite,
    getInvite
};
